import { api } from "./apiConfig";

export const getAccountSettings = async () => {
  try {
    const response = await api.get("/settings/account");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateAccountSettings = async (data) => {
  try {
    const response = await api.patch("/settings/account", data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const closeAccount = async ({ password, confirmPhrase }) => {
  try {
    const response = await api.post("/settings/account/close", {
      password,
      confirmPhrase,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
